<template>
    <div class="index">

        <div class="download-bg">

            <div class="download-bg-content cf">

                    <div class="download-bg-left fl">

                        <div class="download-bg-title">文娱中国</div>

                        <div class="download-bg-subtitle">娱乐资讯平台  追星交友社区</div>

                        <div class="download-bg-box cf">

                            <div class="download-bg-box-btns fl">

                                <div
                                    class="download-bg-box-btn"
                                    v-for="(item,index) in downloadBtns"
                                    :key="'download-bg-box-btn-'+index"
                                    @click="download_image = item.image"
                                >

                                    <img :src="item.icon" />

                                    <span>{{item.value}}</span>

                                </div>

                            </div>

                            <div class="download-img fl">

                                <div class="download-img-box relative">

                                    <img class="absolute" :src="download_image" />

                                </div>

                                <div>扫一扫下载</div>

                            </div>

                        </div>

                    </div>

                    <img class="app-img fr" src="./images/download_img_app@2x.png" />

                </div>

        </div>

        <div class="product">

            <div class="product-title">

                <div>产品功能</div>

                <div class="product-line"></div>

                <div class="product-subtitle">文娱中国APP：来这里开启你的主场</div>

            </div>

            <div class="product-box cf">

                <div class="product-item fl" v-for="item in product">

                    <img class="product-item-img" :src="item.image" />

                    <div class="product-item-title">{{ item.title }}</div>

                    <div class="product-item-line"></div>

                    <div class="product-item-subtitle">{{ item.subtitle }}</div>

                </div>

            </div>

        </div>

        <div class="star">

            <div class="star-bg relative">

                <div class="star-inner-title">有趣的明星动态</div>

                <div class="star-inner-subtitle">关注你喜欢的明星，为TA加油打气</div>

                <div class="star-position"></div>

            </div>

        </div>

        <div class="star-hot">

            <img class="star-hot-title" src="../../assets/images/star_img_title@2x.png" />

            <div class="cf">

                <star-avatar-item
                    class="fl star-hot-item"
                    :width="160"
                    :height="160"
                    v-for="(item,index) in starList"
                    :key="'star-hot-item-'+index"
                    :data="item"
                />

                <star-avatar-item
                    class="fl star-hot-item"
                    :data="more"
                    :width="160"
                    :height="160"
                    color="#d10916"
                    @clickItem="openPage"
                />

            </div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import StarAvatarItem from '../../layout/starAvatarItem/main'
export default {
    name: "download",
    mixins: [mixin],
    components: {
        StarAvatarItem
    }
}
</script>

<style scoped src="./style.css"></style>
